import React, { useContext, useState, useEffect } from "react";
import TransferContext from "../TranferContextProvider.js";
import uploadImg from "../../../images/upload.svg";
import {
  getFileUploadList,
  uplaodFile,
} from "../quickTransferServices/QuickTransferServices.js";
import { notifyWarning } from "../../../util/Notification.js";
import Skeleton from "react-loading-skeleton";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

const UploadFilePolicy = () => {
  const [listUplaod, setListUpload] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingUploadFile, setLoadingUploadFile] = useState(false);
  const [fileNameList, setFileNameList] = useState([]);

  const {
    activeStep,
    setActiveStep,
    skipped,
    setSkipped,
    titleScreen,
    docRange,
    uuid,
    citizenId,
    paymentChannel,
  } = useContext(TransferContext);

  useEffect(() => {
    setLoading(true);
    initialFileUploadList().finally(() => {
      setTimeout(() => setLoading(false), 500);
    });
  }, [activeStep]);

  const initialFileUploadList = async () => {
    const res = await getFileUploadList(docRange);
    if (res?.success === true) {
      let filteredData = res.data;

      if (paymentChannel === "promptpay") {
        if (docRange === 1) {
          filteredData = res.data.filter((f) => f.code !== "MST009_5");
        } else if (docRange === 2) {
          filteredData = res.data.filter((f) => f.code !== "MST010_5");
        } else {
          filteredData = res.data.filter((f) => f.code !== "MST011_3");
        }
      }

      setListUpload(filteredData);
      setFileNameList(Array.from({ length: filteredData.length }, () => ""));
    }
  };

  const uploadQuickFile = async () => {
    let missingRequired = false;
    const formData = new FormData();

    listUplaod.forEach((item) => {
      if (item?.fileContent) {
        formData.append("files", item.fileContent, item.fileContent.name);
        formData.append("codes", item.code);
      } else if (item?.requir === "Y") {
        missingRequired = true;
      }
    });

    if (missingRequired) {
      notifyWarning("กรุณาแนบไฟล์ให้ครบ");
      return;
    }

    formData.append("uuid", uuid);
    formData.append("ageRange", docRange);
    formData.append("citizenId", citizenId);

    try {
      setLoadingUploadFile(true);
      await uplaodFile(formData);
      setLoadingUploadFile(false);
      handleNext();
    } catch (e) {
      setLoadingUploadFile(false);
      notifyWarning("อัปโหลดไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handlerFile = (index, e, fileType) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setListUpload((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], fileContent: file };
      return copy;
    });

    setFileNameList((prev) => {
      const copy = [...prev];
      copy[index] = file.name;
      return copy;
    });
  };

  const isStepSkipped = (step) => skipped?.has?.(step);

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loadingUploadFile}
      >
        <CircularProgress sx={{ animationDuration: "550ms" }} color="inherit" />
      </Backdrop>

      <div className="border-content">
        <div className="title-font">
          {"นำส่งเอกสารแสดงตัวตน " + titleScreen}
        </div>
        <svg height="10" width="100%" style={{ marginTop: 15 }}>
          <line
            x1="0"
            y1="5"
            x2="100%"
            y2="5"
            style={{ stroke: "black", strokeWidth: 0.5 }}
          />
        </svg>

        <div style={{ marginTop: 15 }}>
          {loading ? (
            <div className="p-1">
              <div className="p-1">
                <Skeleton className="h-70px" />
                <Skeleton className="h-30px" />
                <Skeleton className="h-30px" />
                <Skeleton className="h-30px" />
                <Skeleton className="h-30px" />
                <Skeleton className="h-30px" />
                <Skeleton className="h-30px" />
                <Skeleton className="h-30px" />
                <Skeleton className="h-30px" />
              </div>
            </div>
          ) : (
            <>
              {listUplaod.map((item, index) => (
                <div key={item.id ?? index} className="render-file-detail">
                  <div>
                    <span className="consent-font-size">{item.fileType}</span>
                    {item.requir === "Y" && (
                      <span className="text-danger">*</span>
                    )}
                    {fileNameList[index] && (
                      <div
                        className="title-file-font"
                        style={{ marginLeft: 10 }}
                      >
                        {fileNameList[index]}
                      </div>
                    )}
                  </div>

                  <label
                    htmlFor={"file" + (item.id ?? index)}
                    className="btn-upload-file font-size-content-upload d-flex flex-row justify-content-center align-items-center"
                  >
                    <i style={{ fontSize: 14 }}></i> อัพโหลด
                    <img
                      className="icon-image-content-upload"
                      src={uploadImg}
                      style={{ textAlign: "center" }}
                      alt=""
                    />
                    <input
                      type="file"
                      id={"file" + (item.id ?? index)}
                      key={"file" + (item.id ?? index)}
                      accept="image/png, image/jpeg, image/jpg, application/pdf"
                      style={{ display: "none" }}
                      onChange={(e) => handlerFile(index, e, item.fileType)}
                    />
                  </label>
                </div>
              ))}
            </>
          )}
        </div>
      </div>

      <div className="button-contain">
        <button
          style={{ fontSize: 15 }}
          onClick={uploadQuickFile}
          className="btn-checkout-premium w-100 p-2 bold"
        >
          ตกลง
        </button>
        <button className="btn-checkout-back w-100 p-2 bold" onClick={handleBack}>
          กลับ
        </button>
      </div>
    </>
  );
};

export default UploadFilePolicy;
